import {
  UploadLogoEnum,
  UploadLogoResponse,
} from '../../store/modules/company/types'

export const KEY_NAMES_COLORS: UploadLogoResponse = {
  [UploadLogoEnum.PRIMARY]: 'Cor Principal',
  [UploadLogoEnum.SECONDARY]: 'Cor Secundária',
  [UploadLogoEnum.TERTIARY]: 'Cor Auxiliar',
}
